<template>
  <div class="faq__item faq__item_contract" :class="{ active: active }">
    <div
      class="faq__item--question faq__item_contract--question flex j_sb pointer"
      :class="{ collapsed: active }"
      @click="active = !active"
    >
      <div class="flex j_sb container w-100">
        <h2 class="f-16 bold uppercase">{{ question }}</h2>
        <div class="faq__item--cross">
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <slide-up-down
      :active="active"
      :duration="500"
      class="faq__item--collapsed faq__item_contract--collapsed"
    >
      <div class="container">
        <div
          class="flex j_sb faq__item_contract--content"
          v-for="(item, index) in answer"
          :key="index"
        >
          <div class="flex column">
            <span class="medium f-lightgray">{{
              $fn.tr("Insurance Number")
            }}</span>
            <h2 class="bold">{{ item.title }}</h2>
          </div>
          <div class="flex">
            <a
              target="_blank"
              :href="item.link"
              class="button flex a_center j_center faq__item_contract--outer-link"
              v-if="_.get(item, 'link')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.5"
                height="13.5"
                viewBox="0 0 13.5 13.5"
              >
                <g
                  id="Group_5938"
                  data-name="Group 5938"
                  transform="translate(-1396.25 -786.25)"
                >
                  <g
                    id="Group_5937"
                    data-name="Group 5937"
                    transform="translate(1393.035 783.035)"
                  >
                    <path
                      id="Path_2879"
                      data-name="Path 2879"
                      d="M10,11.458a2.613,2.613,0,0,0,3.733,0L16.72,8.471a2.64,2.64,0,0,0-3.733-3.733l-.373.373"
                      transform="translate(-1.529)"
                      fill="none"
                      stroke="#7063e9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_2880"
                      data-name="Path 2880"
                      d="M11.458,9.734a2.613,2.613,0,0,0-3.733,0L4.738,12.721a2.64,2.64,0,0,0,3.733,3.733l.373-.373"
                      transform="translate(0 -1.263)"
                      fill="none"
                      stroke="#7063e9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </g>
              </svg>
            </a>

            <a
              target="_blank"
              :href="_.get(item, 'file[0].url')"
              class="button flex a_center j_center bg-light-purple faq__item_contract--download-btn"
            >
              <span class="f-white f-14 bold">{{ $fn.tr("PDF") }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
              >
                <path
                  id="Combined_Shape"
                  data-name="Combined Shape"
                  d="M5.293,11.707a1,1,0,0,1,0-1.414L8.586,7H1A1,1,0,0,1,1,5H8.586L5.293,1.707A1,1,0,0,1,6.707.292l5,5a1,1,0,0,1,.065,1.342l-.005.006-.01.011-.012.014,0,0-.04.042-5,5a1,1,0,0,1-1.414,0Z"
                  transform="translate(12) rotate(90)"
                  fill="#fff"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </slide-up-down>
  </div>
</template>

<script>
export default {
  props: ["question", "answer"],
  data() {
    return {
      active: false
    };
  }
};
</script>

<style></style>
